import axios from 'axios'
import { env } from '@/utils/env'

const api = axios.create({
  baseURL: env('NEXT_PUBLIC_REST_API_URL'),
  timeout: 30000
})

api.interceptors.request.use(async config => {
  const noLoginToken = env('NEXT_PUBLIC_NO_LOGIN_TOKEN')

  if (noLoginToken) {
    config.headers.Authorization = `Bearer ${noLoginToken}`
  }

  return config
})

export default api
